import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      slogan: "Connect with Geotechnical and Special Foundations Professionals from Around the World",
      nav: {
        home: "Home",
        shop: "Shop",
        rental: "Rental",
        stores: "Stores",
        directory: "Directory",
        cart: "Cart",
        login: "Login",
        register: "Register",
        admin: "Admin",
        logout: "Logout"
      },
      home: {
        hero: "Welcome to GEO TS CONSULTING",
        subtitle: "The first international platform bringing together equipment, suppliers, services and expertise, all in one place, with",
        subtitleBold: "transparency and performance.",
        shopNow: "Shop Now",
        featured: "Featured Products",
        categories: "Categories"
      },
      product: {
        new: "New",
        used: "Used",
        rental: "Rental",
        perDay: "per day",
        inStock: "In Stock",
        outOfStock: "Out of Stock",
        addToCart: "Add to Cart",
        details: "Details",
        reviews: "Reviews",
        addReview: "Add Review"
      },
      cart: {
        title: "Shopping Cart",
        empty: "Your cart is empty",
        total: "Total",
        checkout: "Checkout",
        continueShopping: "Continue Shopping"
      },
      checkout: {
        title: "Checkout",
        name: "Full Name",
        email: "Email",
        address: "Delivery Address",
        paymentMethod: "Payment Method",
        cash: "Cash",
        card: "Credit Card",
        bankTransfer: "Bank Transfer",
        deliveryPayment: "Pay on Delivery",
        placeOrder: "Place Order",
        orderSuccess: "Order placed successfully!"
      },
      rental: {
        title: "Rent Equipment",
        catalog: "Rental Catalog",
        selectProduct: "Select Equipment",
        startDate: "Start Date",
        endDate: "End Date",
        rent: "Rent Now",
        rentalSuccess: "Rental request sent successfully!",
        contactOwner: "Contact Owner",
        technicalSpecs: "Technical Specifications",
        pricing: "Pricing",
        availability: "Availability",
        perDay: "per day",
        perWeek: "per week",
        perMonth: "per month",
        deposit: "Deposit",
        deliveryFee: "Delivery Fee",
        insurance: "Insurance Included",
        messaging: "Messaging",
        sendMessage: "Send Message",
        typeMessage: "Type your message...",
        attachFile: "Attach Photo/Video",
        conversation: "Conversation",
        myConversations: "My Conversations"
      },
      directory: {
        title: "Professional Directory",
        search: "Search companies...",
        contact: "Contact",
        website: "Website"
      },
      admin: {
        dashboard: "Dashboard",
        products: "Products",
        categories: "Categories",
        orders: "Orders",
        rentals: "Rentals",
        rentalMessages: "Rental Messages",
        reviews: "Reviews",
        shops: "Suppliers",
        directory: "Directory",
        productApprovals: "Product Approvals",
        stats: "Statistics",
        totalOrders: "Total Orders",
        totalRevenue: "Total Revenue",
        totalProducts: "Total Products",
        totalUsers: "Total Users",
        addProduct: "Add Product",
        editProduct: "Edit Product",
        deleteProduct: "Delete Product",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit"
      },
      footer: {
        about: "About Us",
        contact: "Contact",
        location: "Location",
        followUs: "Follow Us"
      },
      search: "Search...",
      filter: "Filter",
      all: "All",
      loading: "Loading..."
    }
  },
  fr: {
    translation: {
      slogan: "Connectez-vous avec des Professionnels de la Géotechnique et des Fondations Spéciales du Monde Entier",
      nav: {
        home: "Accueil",
        shop: "Boutique",
        rental: "Location",
        stores: "Fournisseurs",
        directory: "Annuaire",
        cart: "Panier",
        login: "Connexion",
        register: "Inscription",
        admin: "Admin",
        logout: "Déconnexion"
      },
      home: {
        hero: "Bienvenue chez GEO TS CONSULTING",
        subtitle: "La première plateforme internationale qui réunit équipements, fournisseurs, services et expertise, en un seul endroit, avec",
        subtitleBold: "transparence et performance.",
        shopNow: "Acheter Maintenant",
        featured: "Produits en Vedette",
        categories: "Catégories"
      },
      product: {
        new: "Neuf",
        used: "Occasion",
        rental: "Location",
        perDay: "par jour",
        inStock: "En Stock",
        outOfStock: "Rupture de Stock",
        addToCart: "Ajouter au Panier",
        details: "Détails",
        reviews: "Avis",
        addReview: "Ajouter un Avis"
      },
      cart: {
        title: "Panier d'Achat",
        empty: "Votre panier est vide",
        total: "Total",
        checkout: "Commander",
        continueShopping: "Continuer les Achats"
      },
      checkout: {
        title: "Commander",
        name: "Nom Complet",
        email: "Email",
        address: "Adresse de Livraison",
        paymentMethod: "Mode de Paiement",
        cash: "Espèces",
        card: "Carte Bancaire",
        bankTransfer: "Virement Bancaire",
        deliveryPayment: "Paiement à la Livraison",
        placeOrder: "Passer la Commande",
        orderSuccess: "Commande passée avec succès!"
      },
      rental: {
        title: "Louer un Équipement",
        catalog: "Catalogue de Location",
        selectProduct: "Sélectionner un Équipement",
        startDate: "Date de Début",
        endDate: "Date de Fin",
        rent: "Louer Maintenant",
        rentalSuccess: "Demande de location envoyée avec succès!",
        contactOwner: "Contacter le Loueur",
        technicalSpecs: "Fiche Technique",
        pricing: "Tarification",
        availability: "Disponibilité",
        perDay: "par jour",
        perWeek: "par semaine",
        perMonth: "par mois",
        deposit: "Caution",
        deliveryFee: "Frais de Livraison",
        insurance: "Assurance Incluse",
        messaging: "Messagerie",
        sendMessage: "Envoyer un Message",
        typeMessage: "Tapez votre message...",
        attachFile: "Joindre Photo/Vidéo",
        conversation: "Conversation",
        myConversations: "Mes Conversations"
      },
      directory: {
        title: "Annuaire Professionnel",
        search: "Rechercher des entreprises...",
        contact: "Contact",
        website: "Site Web"
      },
      admin: {
        dashboard: "Tableau de Bord",
        products: "Produits",
        categories: "Catégories",
        orders: "Commandes",
        rentals: "Locations",
        rentalMessages: "Messages de Location",
        reviews: "Avis",
        shops: "Fournisseurs",
        directory: "Annuaire",
        productApprovals: "Approbation Produits",
        stats: "Statistiques",
        totalOrders: "Total Commandes",
        totalRevenue: "Revenu Total",
        totalProducts: "Total Produits",
        totalUsers: "Total Utilisateurs",
        addProduct: "Ajouter Produit",
        editProduct: "Modifier Produit",
        deleteProduct: "Supprimer Produit",
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier"
      },
      footer: {
        about: "À Propos",
        contact: "Contact",
        location: "Localisation",
        followUs: "Suivez-nous"
      },
      search: "Rechercher...",
      filter: "Filtrer",
      all: "Tous",
      loading: "Chargement..."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    lng: 'fr', // Force French as default language
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;